module.exports = __webpack_public_path__ + "media/newstyle/images/first-circle-f4a62ae3ae9e4e96dd1a9c9ef267f543.svg";